import { Award, Footprints, Route, CheckCheck, Flame, TrendingUp, CalendarCheck, Trophy } from "lucide-react";
import { Card } from "./ui";

const ICON = { inizio: Footprints, percorso: Route, routine1: CheckCheck, costanza7: Flame, check1: CalendarCheck, crescita: TrendingUp, check4: Award, costanza30: Trophy };

export default function Badges({ badges = [] }) {
  const got = badges.filter((b) => b.ottenuto).length;
  const next = badges.find((b) => !b.ottenuto && b.key !== "percorso");
  return (
    <div className="mt-8" data-testid="badges">
      <div className="flex items-center justify-between"><p className="font-club-display text-2xl">I tuoi traguardi</p><span className="text-xs text-[#9A948A]" data-testid="badges-count">{got}/{badges.length}</span></div>
      {next && <p className="text-sm text-[#9A948A] mt-1">Prossimo: <b className="text-[#F4EFE6]">{next.titolo}</b>, {next.testo.charAt(0).toLowerCase() + next.testo.slice(1)}</p>}
      <Card className="mt-4 grid grid-cols-4 gap-3 p-4">
        {badges.map((b) => {
          const Icon = ICON[b.key] || Award;
          return (
            <div key={b.key} title={b.testo} data-testid={`badge-${b.key}`} data-ottenuto={b.ottenuto} className={`flex flex-col items-center text-center gap-1.5 ${b.ottenuto ? "" : "opacity-35"}`}>
              <span className={`h-12 w-12 rounded-2xl flex items-center justify-center ${b.ottenuto ? "bg-[#E5B13A] text-[#15120A] shadow-[0_0_24px_rgba(229,177,58,0.35)]" : "bg-[#1C1C20] text-[#9A948A] border border-dashed border-[#3A3A42]"}`}><Icon size={20} /></span>
              <span className="text-[0.6rem] leading-tight font-semibold">{b.titolo}</span>
            </div>
          );
        })}
      </Card>
    </div>
  );
}
